import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { games as gamesApi } from "../lib/api";
import GameBoard from "../components/GameBoard";

export default function GamePlayPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [game, setGame] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    gamesApi.get(id).then(setGame).catch(() => setErr(true));
  }, [id]);

  if (err) {
    return (
      <div className="min-h-screen bg-[#0A1329] text-white grid place-items-center px-6 text-center" data-testid="game-not-found">
        {t("games.not_found")}
      </div>
    );
  }
  if (!game) {
    return <div className="min-h-screen bg-[#0A1329] text-white grid place-items-center">{t("common.loading")}</div>;
  }
  return (
    <GameBoard
      game={game}
      canSave
      onSaveMatch={(data) => gamesApi.recordMatch(data)}
      onExit={() => navigate("/games")}
    />
  );
}
